import rawEmojis from './emoji.json';

export type EmojiCode = string;

/** Definition for an emoji */
export interface EmojiDef {
    name: string;
    shortname: string;
    category: string;
    diversity?: null | string[];
    keywords: string[];
    code: EmojiCode;
    order: number;

    /**
     * Complete fully-qualified UTF-8 sequence for the emoji.
     * If not present, the emoji is a single code point that can be used as-is.
     */
    utf8?: string;
}

/**
 * Cache bust for emoji assets (images or css).
 */
export const cacheBust: string = rawEmojis.cacheBust;

/**
 * Map of all emojis by code
 */
export const emojisByCode: {
    [code: string]: EmojiDef;
} = rawEmojis.emojis;

/**
 * Map of all emojis by shortname
 */
export const emojisByShortname: { [shortname: string]: EmojiDef } = {};

/** Listing of all emojis */
export const emojis: EmojiDef[] = [];

Object.keys(emojisByCode).forEach((code) => {
    const emoji = emojisByCode[code];
    if (!emoji) {
        return;
    }

    const emojiCode = emojisByCode[code];
    if (!emojiCode) {
        return;
    }

    emojiCode.code = code;
    emojisByShortname[emoji.shortname] = emoji;

    // Only the "primary" diversity code is listed in the main list
    if (!emoji.diversity && emoji.category !== 'modifier' && emoji.category !== 'regional') {
        emojis.push(emoji);
    }
});

if (emojisByShortname[':thumbsup:']) {
    emojisByShortname[':+1:'] = emojisByShortname[':thumbsup:'];
}
if (emojisByShortname[':thumbsdown:']) {
    emojisByShortname[':-1:'] = emojisByShortname[':thumbsdown:'];
}

emojis.sort((emojiA, emojiB) => emojiA.order - emojiB.order);
